import type { RemoteTrackPublication } from 'livekit-client';

type LiveKit215AdaptiveStreamPublication = {
  requestedDisabled: boolean | undefined;
  emitTrackUpdate?: () => void;
};

/**
 * Return publication enablement to LiveKit 2.15.2 adaptive-stream control.
 */
export const restoreLiveKit215AdaptiveStreamControl = (
  publication: RemoteTrackPublication
): boolean => {
  try {
    // LiveKit 2.15.2 has no public API for clearing its sticky manual enable override.
    const compatPublication = publication as unknown as LiveKit215AdaptiveStreamPublication;
    if (
      !('requestedDisabled' in compatPublication) ||
      (compatPublication.requestedDisabled !== undefined &&
        typeof compatPublication.requestedDisabled !== 'boolean') ||
      typeof compatPublication.emitTrackUpdate !== 'function'
    ) {
      return false;
    }

    compatPublication.requestedDisabled = undefined;
    compatPublication.emitTrackUpdate();
    return true;
  } catch {
    // SDK internals may change; bandwidth recovery must never crash the room path.
    return false;
  }
};
